import { NavCloseIcon, OutlinedInfoIcon } from 'assets/icons';
import { CustomButton, CustomModal } from 'components';
import { FC } from 'react';
import { VoidFn } from 'types/baseTypes';

const DEFAULT_TITLE = 'Invoice total mismatch';
const DEFAULT_SUBTITLE = `The total amount on this invoice does not match the amount shown in the uploaded document.
\n\nPlease review and correct the amounts before proceeding.`;

interface AutofillAmountMismatchPopupProps {
  onClose: VoidFn;
  title?: string;
  subTitle?: string;
}

const AutofillAmountMismatchPopup: FC<AutofillAmountMismatchPopupProps> = ({
  onClose,
  title = DEFAULT_TITLE,
  subTitle = DEFAULT_SUBTITLE
}) => {
  return (
    <CustomModal open={true} width="md:w-[355px]">
      <div className="relative">
        <div
          className="absolute right-4 top-4 cursor-pointer"
          onClick={onClose}
          role="button"
          tabIndex={0}
          aria-label="Close">
          <NavCloseIcon />
        </div>
        <div className="flex flex-col items-center gap-3.5 p-4">
          <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-full bg-[#FFE5E5]">
            <OutlinedInfoIcon className="path-fill-current h-8 w-8 text-error" />
          </div>

          <div className="text-center text-17px font-semibold text-primaryText">{title}</div>

          <div className="whitespace-pre-line text-center text-sbase text-primaryText">{subTitle}</div>
        </div>
        <div className="m-4 mt-0">
          <CustomButton
            id="autofill-amount-mismatch-okay-btn"
            onClick={onClose}
            className="h-12 w-full"
            aria-label="Okay">
            Okay
          </CustomButton>
        </div>
      </div>
    </CustomModal>
  );
};

export default AutofillAmountMismatchPopup;
